import { InboxSectionEnum } from 'Modules/Communication/shared/models/Inbox'

export const convertEnumToReadable = (
  input: InboxSectionEnum,
  sms: boolean = false
) => {
  switch (input) {
    case InboxSectionEnum.Received:
      return 'Innboks'
    case InboxSectionEnum.Sent:
      return 'Sendt'
    case InboxSectionEnum.Processed:
      return 'Behandlet'
    case InboxSectionEnum.Draft:
      return 'Utkast'
    case InboxSectionEnum.Junk:
      return 'Søppelpost'
    case InboxSectionEnum.Deleted:
      return 'Slettet'
    case InboxSectionEnum.All:
      return 'Etikett'
    default:
      return sms ? 'Sendt' : 'Innboks'
  }
}

export const convertReadableToEnum = (input: string, sms: boolean = false) => {
  switch (input?.toLowerCase()) {
    case 'innboks':
      return InboxSectionEnum.Received
    case 'sendt':
      return InboxSectionEnum.Sent
    case 'behandlet':
      return InboxSectionEnum.Processed
    case 'utkast':
      return InboxSectionEnum.Draft
    case 'søppelpost':
      return InboxSectionEnum.Junk
    case 'slettet':
      return InboxSectionEnum.Deleted
    case 'etikett':
      return InboxSectionEnum.All
    default:
      return sms ? InboxSectionEnum.Sent : InboxSectionEnum.Received
  }
}

export const getDefaultSortColumnForSection = (section: InboxSectionEnum) => {
  switch (section) {
    case InboxSectionEnum.Deleted:
      return 'createdDate'
    case InboxSectionEnum.Draft:
      return 'createdDate'
    case InboxSectionEnum.Sent:
      return 'sentDate'
    case InboxSectionEnum.Received:
      return 'createdDate'
    default:
      return 'createdDate'
  }
}
